<ion-grid
  fixed="true"
  class="ion-padding-vertical-0"
>
  <ion-row>
    <ion-col size="12">
      <div class="card-buttons">
        <div class="card-buttons--start">
          <ion-button
            fill="outline"
            (click)="addStop()"
          >
            Añadir parada
          </ion-button>
        </div>

        <div class="card-buttons--end">
          <ion-button
            (click)="updateOrCreateFreight()"
            color="primary"
            expand="block"
            fill="solid"
            size="large"
            [disabled]="isOffline()"
          >
            @if (isNew()) {
              Publicar carga
            } @else {
              Guardar cambios
            }
          </ion-button>
        </div>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
